import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { SelectDesktop } from './SelectDesktop';
import { SelectMobile } from './SelectMobile';

// Custom selects
import { SelectDesktopWithDefault } from './SelectDesktopWithDefault';
import { SelectMobileWithDefault } from './SelectMobileWithDefault';
import { useWindowSizeV2 } from 'common/react/hooks/use-window-resize';

/**
 * @param {object} props - Props.
 * @param {string} props.label - Label.
 * @param {string} props.className - Class name for the select.
 * @param {any[]} props.items - Items.
 * @param {Function} [props.itemToString] - Item to string.
 * @param {Function} [props.selectedItemToString] - selectedItem to string (shown as the selection in the input).
 * @param {any} [props.initialSelectedItem] - Initial selected item.
 * @param {any} [props.activeItem] - Active item from state.
 * @param {Function} [props.onSelectedItemChange] - On change callback.
 * @param {boolean} [props.isDisabled] - Is select disabled.
 * @returns {React.Element} Component.
 */
export const Select = (props) => {
    const windowSize = useWindowSizeV2();

    const showResponsiveItems = useMemo(() => {
        return windowSize.width <= PULSE.app.measurements.desktop;
    }, [windowSize.width]);

    const selectDesktopComponent = () => {
        switch (props.type) {
            case 'with-default':
                return <SelectDesktopWithDefault {...props} />;
            default:
                return <SelectDesktop {...props} />;
        }
    };

    const selectMobileComponent = () => {
        switch (props.type) {
            case 'with-default':
                return <SelectMobileWithDefault {...props} />;
            default:
                return <SelectMobile {...props} />;
        }
    };

    return showResponsiveItems
        ? selectMobileComponent()
        : selectDesktopComponent();
};

Select.propTypes = {
    label: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.any),
    className: PropTypes.string,
    itemToString: PropTypes.func,
    selectedItemToString: PropTypes.func,
    initialSelectedItem: PropTypes.any,
    activeItem: PropTypes.any,
    onSelectedItemChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    hideLabel: PropTypes.bool,
    showTeamLogo: PropTypes.bool,
    displaySlim: PropTypes.bool,
    showTotals: PropTypes.bool,
    showCompLogo: PropTypes.bool,
    type: PropTypes.string
};
